import SuperRepository from '../superRepository'

export default new (class RetargetingAudienceRepository extends SuperRepository {
  baseUri() {
    return 'retargeting_audience'
  }
  getRuns = (id, params) => this.httpClient().get(`${this.baseUri()}/${id}/runs`, params)
  pause = id => this.httpClient().post(`${this.baseUri()}/${id}/pause`)
  resume = id => this.httpClient().post(`${this.baseUri()}/${id}/resume`)
  segmentAvailable = params => this.httpClient().get(`${this.baseUri()}/segment_available`, params)
  refresh = id => this.httpClient().post(`${this.baseUri()}/${id}/refresh`)
})()
